<template>
    <li v-bind:class="{ active: site.selected }">
        <p>{{site.icon}}&nbsp;<a v-on:click="toggleSelected" href="#">{{site.title}}</a>&nbsp;<a v-if="site.group != null" v-on:click="toggleGroupSelected" href="#">[{{site.group.name}}]</a>&nbsp;<a :href="site.url" target="_blank" class="_blank">&#10064;</a></p>
        <template v-if="!simple">
            <p class="stats" v-if="site.metrika">
                <span v-bind:class="[classFor(visitsDiff), 'metrika']" v-if="site.metrika" v-bind:title="titleFor(visitsDiff, site.metrika.today.visits)">{{ site.metrika.today.visits }}</span>/
                <span v-bind:class="[classFor(pageviewsDiff), 'metrika']" v-if="site.metrika" v-bind:title="titleFor(pageviewsDiff, site.metrika.today.pageviews)">{{ site.metrika.today.pageviews }}</span>/
                <span v-bind:class="[classFor(usersDiff), 'metrika']" v-if="site.metrika" v-bind:title="titleFor(usersDiff, site.metrika.today.users)">{{ site.metrika.today.users }}</span>
                <span class="moz_rank" v-if="site.moz_rank" v-bind:title="'DA/PA, Last update: ' + site.moz_rank.date">{{ niceIntNumber(site.moz_rank.da, '00') + '/' + niceIntNumber(site.moz_rank.pa, '00')}}</span>
            </p>
            <p class="stats" v-if="site.metrika">
                <span v-bind:class="[classFor(visitsDiff), 'metrika']" v-if="site.metrika" v-bind:title="titleFor(visitsDiff, site.metrika.today.visits)">{{titleFor(visitsDiff, site.metrika.today.visits)}}</span>/
                <span v-bind:class="[classFor(pageviewsDiff), 'metrika']" v-if="site.metrika" v-bind:title="titleFor(pageviewsDiff, site.metrika.today.pageviews)">{{titleFor(pageviewsDiff, site.metrika.today.pageviews)}}</span>/
                <span v-bind:class="[classFor(usersDiff), 'metrika']" v-if="site.metrika" v-bind:title="titleFor(usersDiff, site.metrika.today.users)">{{ titleFor(usersDiff, site.metrika.today.users) }}</span>
                <span class="moz_rank" v-if="site.moz_rank" v-bind:title="'DA/PA, Last update: ' + site.moz_rank.date"></span>
            </p>
            <p class="stats" v-else>
                <span class="metrika gray">no metrika data</span>
                <span class="moz_rank" v-if="site.moz_rank" v-bind:title="'DA/PA, Last update: ' + site.moz_rank.date">{{ niceIntNumber(site.moz_rank.da, '00') + '/' + niceIntNumber(site.moz_rank.pa, '00')}}</span>
            </p>
        </template>
    </li>
</template>

<script>
    export default {
        name: "SiteItem",
        data: function (){
              return {
                  visitsDiff: 0,
                  pageviewsDiff: 0,
                  usersDiff: 0
              }
        },
        mounted: function (){
            if (!this.site.metrika){
                return
            }

            this.visitsDiff = this.site.metrika.today.visits - this.site.metrika.yesterday.visits;
            this.pageviewsDiff = this.site.metrika.today.pageviews - this.site.metrika.yesterday.pageviews;
            this.usersDiff = this.site.metrika.today.users - this.site.metrika.yesterday.users;
        },
        props:{
            site: Object,
            selectSite: Function,
            setGroup: Function,
            getGroupById: Function,
            simple: Boolean
        },
        methods:{
            titleFor(diff, today){
                let percents = Math.round(diff * 100 / today);
                if (diff < 0){
                    return diff + '(' + percents + '%)';
                }else{
                    return '+' + diff + '(' + percents + '%)';
                }
            },
            percentsFor(diff, today){
                let percents = Math.round(diff * 100 / today);
                if (diff < 0){
                    return percents;
                }else{
                    return '+' + percents;
                }
            },
            classFor(diff){
                if (diff < 0){
                    return 'red';
                }
                if (diff > 0){
                    return 'green';
                }
            },
            toggleSelected: function (){
                this.selectSite(this.site);
            },
            toggleGroupSelected: function () {
                this.setGroup(this.getGroupById(this.site.group.id));
            }
        }
    }
</script>


<style scoped>
    p.stats{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    #sites_list li span.metrika{
        flex: 1.5;
        margin: 0;
        text-shadow: 1px 1px 0px #CCCCCC;
        color: #999999;
        float: left;
        vertical-align: middle;
        font-size: 1.2rem;
        font-weight: bold;
        font-family: monospace;
    }

    #sites_list li span.metrika.red{
        text-shadow: 1px 1px 0px #FF00FF;
        color: #ff052c;
    }

    #sites_list li span.metrika.green{
        text-shadow: 1px 1px 0px #ff7a2c;
        color: #4bff6a;
    }

    #sites_list li span.metrika.gray{
        font-size: 1.5rem;
        color: #999;
        text-shadow: 1px 1px 0px #ccc;
    }

    #sites_list li span.moz_rank{
        text-align: right;
        flex: 1;
        margin: 0;
        text-shadow: 2px 2px 0px #F0F;
        color: #ff7a2c;
        float: right;
        vertical-align: middle;
        font-size: 1.5rem;
        font-weight: bold;
        mix-blend-mode: difference;
        font-family: monospace;
    }
</style>
